// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__KyRFQ","logo":"Navbar_logo__3H5Zh","bell":"Navbar_bell__ptPEP","user":"Navbar_user__S7jYJ","config":"Navbar_config__tTdbL"};